import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HotelDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class HotelApiClient extends BaseCRUDApiClient<HotelDtoModel> {
  baseUrl = this.config.apiEndpoint + '/hotel';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
